import { useEffect, useId, useMemo, useState } from "react";
import { Login } from "./Login";
import { Login_dev } from "./Login_Dev";
import RegisterComponent from "./RegisterUser";
import { VerifyOtp } from "./VerifyOtp";
import { useSelector } from "react-redux";
import { selectLoggedUser, selectOpenLoginModal, setOpneLoginModal } from "../../redux/slices/auth";
import { Modal } from "./Modal";
import { useModal } from "../../hooks/useModal";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SitePath, slideInFromRight } from "../../shared/constants";
import { useNavigationType, NavigationTypeEnum } from "../../hooks/useNavigationType";
import { motion as m, AnimatePresence } from "framer-motion";
import { loginStartedEvent } from "../../shared/events/login.event";


enum ModalVariant {
  loginModal = 'LoginModal',
  verifyOtpModal = 'VerifyOtpModal',
  registerModal = 'RegisterModal'
}

export const LoginModal = ({ isVisible, utmQuery }: { isVisible?: boolean, utmQuery?: any }) => {
  const key = useId()
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigationType = useNavigationType();
  const modalId = `${key}-cart-summary`
  const [currentView, setCurrentView] = useState<'login' | 'register' | 'verifyOtp'>('login');
  const [isNavigate, setIsNavigate] = useState(false);
  const [loginFocusTrigger, setLoginFocusTrigger] = useState(0);
  const [otpFocusTrigger, setOtpFocusTrigger] = useState(0);
  const { open, close } = useModal(modalId);
  const [userId, setUserId] = useState<number>()
  const [mobileNumber, setMobileNumber] = useState<string>()
  const authInfo = useSelector(selectLoggedUser)
  const [modalVariant, setModalVariant] = useState<ModalVariant>(ModalVariant.loginModal);
  const [origin, setOrigin] = useState<'login' | 'register' | 'verifyOtp'>('login');
  const [resetTrigger, setResetTrigger] = useState(0);

  const showModal = useSelector(selectOpenLoginModal)
  isVisible = showModal

  const handleLoginClick = (showRegister: boolean, user_id: number, mobile_no: string) => {
    setUserId(user_id)
    setMobileNumber(mobile_no)
  }

  const handleLoginSuccess = (bool: boolean) => {
    if (bool == true)
      setCurrentView('verifyOtp')
  }

  const handleAfterOptSuccess = (bool: boolean) => {
    setCurrentView('register')
    setOrigin('verifyOtp')
    setMobileNumber('') // Clear mobile number after successful OTP verification
  }

  const isRegistrationCompleted = (bool: boolean) => {
    if (bool) {
      close()
    }
  }

  const handleclose = () => {
    dispatch(setOpneLoginModal(false))
    setCurrentView('login')
    setMobileNumber('') // Clear mobile number when modal closes
    setResetTrigger(prev => prev + 1) // Trigger reset in Login component
  };

  useEffect(() => {
    if (isVisible) {
      open();
    }
  }, [isVisible, open, close]);

  useEffect(() => {
  if (showModal && currentView === "login") {
    loginStartedEvent(location.pathname);
  }
}, [showModal]);

  useEffect(() => {
    const element = document.getElementById(modalId);
    if (!element) return;
    const handleShown = () => {
      if (currentView === "login") {
        setLoginFocusTrigger((prev) => prev + 1);
      } else if (currentView === "verifyOtp") {
        setOtpFocusTrigger((prev) => prev + 1);
      }
    };
    element.addEventListener("shown.bs.modal", handleShown);
    return () => {
      element.removeEventListener("shown.bs.modal", handleShown);
    };
  }, [modalId, currentView]);

  useEffect(() => {
    if (!isVisible) return;
    if (currentView === "login") {
      setLoginFocusTrigger((prev) => prev + 1);
    } else if (currentView === "verifyOtp") {
      setOtpFocusTrigger((prev) => prev + 1);
    }
  }, [isVisible, currentView]);

  useEffect(() => {
    if (navigationType == NavigationTypeEnum.Reload) {
      console.log("Reload")
    }
    dispatch(setOpneLoginModal(false))
    setCurrentView('login')
    close()
  }, [location.pathname, navigationType])

  const ModalHeaderImage = <div className="pop_title">
    <img
      src="https://selsmart.in/selsmart.png"
      alt="Selsmart Logo"
      style={{ width: "140px", marginTop: "20px", display: "none" }}
    />

  </div>



  const showCloseIcon = useMemo(() => {

    if (currentView == 'register')
      return true

    if (location.pathname == SitePath.SELL_NOW_PAGE)
      return true

    return location.pathname.includes("sell-") ? false : true
  }, [location.pathname, currentView])

  const ModalHeader = useMemo(() => {
    if (currentView === 'login') return ModalHeaderImage
    if (currentView === 'register') return 'Profile'
    if (currentView === 'verifyOtp') return ModalHeaderImage
  }, [currentView])
  return (

    <Modal id={modalId} showCloseButton={showCloseIcon} staticBackdrop={true} title={ModalHeader} onClose={handleclose}>
      <m.div >
        <AnimatePresence mode="wait">
          {currentView === "login" && (
            // <Login_dev/>
            <m.div className="popup-content-city"
              key="login"
              variants={slideInFromRight}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.2 }}
            >


              <p className="exact-value-popup" style={{ visibility: "hidden", display: "none" }}>
                <span style={{ color: "red" }}>*</span>
                <span style={{ color: "red" }}>*</span>To get Exact Value.
              </p>

              <Login
                redirectUrl={false}
                setIsNavigation={setIsNavigate}
                utmQuery={"someValue"}
                handleLogin={handleLoginClick}
                isVisible={isVisible && currentView === 'login'}
                focusTrigger={loginFocusTrigger}
                handleLoginSuccess={handleLoginSuccess}
                initialMobileNo={mobileNumber}
                resetTrigger={resetTrigger}
              />

            </m.div>

          )}

          {currentView === "verifyOtp" && (
            <m.div className="popup-content-city"
              key="verifyOtp"
              variants={slideInFromRight}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.2 }}
            >
              <div className="otp-form">
                <div className="pop_title">Verify Mobile Number</div>
                <VerifyOtp
                  handleAfterOptSuccess={handleAfterOptSuccess}
                  userId={userId as number}
                  userInfo={userId}
                  mobileNo={mobileNumber}
                  onClose={close}
                  focusTrigger={otpFocusTrigger}
                  setCurrentView={setCurrentView}
                ></VerifyOtp>


              </div>
            </m.div>
          )}

          {currentView === 'register' && (
            <m.div className="px-4 py-2"
              key="register"
              variants={slideInFromRight}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.2 }}
            >


              <RegisterComponent setCurrentView={setCurrentView} handleLogin={handleLoginClick} origin={origin} isRegistrationCompleted={isRegistrationCompleted} />
            </m.div>

          )}
        </AnimatePresence>
      </m.div>
    </Modal>

  )
}
